import PrivateNetworkClient from "helpers/privateNetwork";

const getZoneList = async (formData) => {
  if(localStorage.getItem('token') === null) {
    return null;
  }
  const { data } = await PrivateNetworkClient.post("/site/siteList", formData);
  return data;
};

const addZone = async (formData) => {
  const { data } = await PrivateNetworkClient.post("/rfid/addSite", formData);
  return data;
};

const editZone = async (formData) => {
  const { data } = await PrivateNetworkClient.put("/rfid/editSite", formData);
  return data;
};

const deleteZone = async (id) => {
  const { data } = await PrivateNetworkClient.delete(`/site/delete/${id}`);
  return data;
};

const statusSite= async (id) => {
  const { data } = await PrivateNetworkClient.put(`/site/changeStatus/${id}`);
  return data;
}

const getZoneDropdown = async () => {
  if(localStorage.getItem('token') === null) {
    return null;
  }
  const { data } = await PrivateNetworkClient.get("/zone/dropdown");
  return data;
};

const getZoneEditDropdown = async (id) => {
  const { data } = await PrivateNetworkClient.get(`/zone/dropdown-edit/${id}`);
  return data;
};

const getSiteDropdown = async () => {
  if(localStorage.getItem('token') === null) {
    return null;
  }
  const { data } = await PrivateNetworkClient.get("/site/dropdown");
  return data;
};
const getLocationDropdown = async (id) => {
  if(localStorage.getItem('token') === null) {
    return null;
  }
  const { data } = await PrivateNetworkClient.get(`/location/dropdown/${id}`);
  return data;
};

export {
  getZoneList,
  addZone,
  editZone,
  deleteZone,
  getZoneDropdown,
  getZoneEditDropdown,
  getSiteDropdown,
  getLocationDropdown,
  statusSite
};
